<script>
export default {

  name: 'orderheader',

  props: {
    recallDisplay: {
      type: Boolean,
      default: false
    },

    checkNum: {
      type: Number,
      default: 0
    },

    revenueType: {
      type: String,
      default: ''
    },

    firstName: {
      type: String,
      default: ''
    },

    lastName: {
      type: String,
      default: ''
    },

    id: {
      type: String,
      default: ''
    },

    time: {
      type: String,
      default: ''
    },

    timeColour: {
      type:String,
      default: 'green'
    },

    postPay: {
      type: Boolean,
      default: false
    },

    closedDate: {
      type: String,
      default: ''
    }

  
  },

  methods: {
    displayHeader(revenueType, lastName) {
      if (lastName.substring(0,4).toLowerCase() == revenueType.substring(0,4).toLowerCase()) {
        return revenueType;
      } else {
        return lastName + ' - ' + revenueType;
      }
    }

  },

  mounted: function(){
    //console.log('order header');

  },

  data() {
    return {
    }
  }

}
</script>

<template>
<div>
  <div v-if="recallDisplay" 
    style="text-align: center;
           font-weight: bold;
           font-size: large;
           padding: 0px;
           "
  >
    <span class="pull-left"># {{checkNum}}</span>
    <span v-if="time" class="pull-right"
     :style="'font-size: smaller; color: ' + timeColour" >{{time}}</span>
    <br clear="all">
    <div style="margin: 5px 0px 0px 0px; font-size: medium;">{{displayHeader(revenueType, lastName)}}</div>
    <div v-if="id" 
     style="border: solid green 1px; 
            padding: 5px 10px; 
            margin: 3px 0px 0px 0px;
            text-align: left;
            font-size: smaller;"
    >
      {{$t('name')}}:<br>{{'&nbsp;' + id}}
    </div>

  </div>
  <div v-else 
    style="text-align: center;  font-weight: bold;  font-size: large;"
  >
    <span style="float: left; margin-right: 20px;"># {{checkNum}}
      <span v-if="id" style="margin-left: 10px;">{{id}}</span>
    </span>
    <span v-if="time" :style="'float: right; color: ' + timeColour" > {{time}}</span> 
    <br>
    <div style="margin: 5px 2px 0px 2px;">{{displayHeader(revenueType, lastName)}}</div>
    <div v-if="postPay && !closedDate" style="margin: 3px 0px -10px 0px;">
      <span v-if="!closedDate" style="color: red;">** NOT PAID **</span>
      <!-- <span v-else style="color: green;">** PAID **</span>-->
    </div>
  </div>

</div>
</template>


// WEBPACK FOOTER //
// OrderHeader.vue?747eacc8